<template>
  <span @click="visible = true" >
    <slot>
      <button class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text">
        <i class="pi pi-pen-to-square"></i>
      </button>
    </slot>
  </span>

  <Dialog v-model:visible="visible" modal :header="title" :style="{ width: '25rem' }" pt:root:class="edit-cliente-modal">

    <template v-if="extraaction">
      <FormInput
        :dati="extrainfo"
        :formlabel="extralabel"
        :idform="idform"
        :stilestruttura="stilestruttura"
        :recaptcha="recaptcha"
        :action="extraazione"
        ref="extramodalinput">
      </FormInput>
      <div class="flex justify-center gap-2 mt-4 form-actions">
        <Button type="button" icon="pi pi-times" :label="testoannulla" severity="secondary" @click="visible = false"></Button>
        <Button type="button" icon="pi pi-save" :label="testoconferma" @click="$refs.extramodalinput.checkForm(0)"></Button>
      </div>
      <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700"/>
    </template>
    <FormInput
      :dati="info"
      :formlabel="label"
      :idform="idform"
      :stilestruttura="stilestruttura"
      :recaptcha="recaptcha"
      :action="azione"
      ref="modalinput">
    </FormInput>
    <div class="flex justify-center gap-2 mt-4  form-actions">
      <Button type="button" icon="pi pi-times" :label="testoannulla" severity="secondary" @click="visible = false"></Button>
      <Button type="button" icon="pi pi-save" :label="testoconferma" @click="$refs.modalinput.checkForm(0)"></Button>
    </div>
  </Dialog>
</template>

<script>

import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import DatePicker from 'primevue/datepicker';
import FormInput from './FormInput.vue';


export default {
  name: "ButtonModalForm",
  components: {
    InputText,
    Dialog,
    DatePicker,
    Button,
    FormInput
  },
  props: ['action', 'dati', 'struttura', 'testoannulla', 'testoconferma', 'title', 'id', 'recaptcha', 'stilestruttura', 'extraaction','extradati','extrastruttura'],
  data() {
    return {
      visible: false,
      id: this.id,
      azione: this.action,
      info: typeof this.dati === 'string' ? JSON.parse(this.dati) : (this.dati || {}),
      label: typeof this.struttura === 'string' ? JSON.parse(this.struttura) : (this.struttura || []),
      extrainfo: this.extradati ? (typeof this.extradati === 'string' ? JSON.parse(this.extradati) : this.extradati) : {},
      extralabel: this.extrastruttura ? (typeof this.extrastruttura === 'string' ? JSON.parse(this.extrastruttura) : this.extrastruttura) : {},
      extraazione: this.extraaction,
      errors: {},
      imginput: false,
      idform: this.id,
    };
  },
  mounted() {
    console.log(this.info, this.label);
    const thiz = this
    document.addEventListener('formChanged', function (e) {
      this.label = e.detail.newStruttura;
      if (e.detail.newData) {
        thiz.updateData(e.detail.newData)
      }

    });
  },
  methods: {
    updateData: function (newData) {
      this.$refs["modalinput"].info = newData;
    }
  }
}
</script>

<style scoped>

</style>
